export const SET_LOGGED_IN = 'SET_LOGGED_IN';
export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_LOGO_NON_LOGIN = 'SET_LOGO_NON_LOGIN';
export const SET_CUSTOMER_PORTAL = 'SET_CUSTOMER_PORTAL';
export const SET_SHOW_ROUTE = 'SET_SHOW_ROUTE';
